import _axios from "axios"
import { datadogLogs } from '@datadog/browser-logs'

const axios = (baseURL) => {

    const instance = _axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
            	"Content-type": "application/json"
            },
            timeout: 6000,
        });

    if (process.env.REACT_APP_ENV.trim() === "dev" || process.env.REACT_APP_ENV.trim() === "stage"){
		datadogLogs.init({
			clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
			site: process.env.REACT_APP_DATADOG_SITE,
			service:'qbarn',
			env:process.env.REACT_APP_ENV,
			forwardErrorsToLogs: true,
			sampleRate: 100,
		})
	}
     return instance;
}

export {axios};
export default axios();